var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPercentDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3951 5.46332C12.6916 5.68166 12.7549 6.099 12.5366 6.39546C12.367 6.62573 12.1974 6.84462 12.0486 7.03526C11.7516 7.41584 11.3427 7.92553 10.8985 8.43717C10.4571 8.9455 9.96774 9.47101 9.51088 9.87467C9.28321 10.0758 9.04791 10.2608 8.81846 10.3992C8.60732 10.5264 8.31719 10.6667 7.99977 10.6667C7.68235 10.6667 7.3922 10.5264 7.18105 10.3992C6.9516 10.2608 6.7163 10.0758 6.48863 9.87467C6.03177 9.47101 5.54242 8.9455 5.10106 8.43717C4.65682 7.92553 4.24794 7.41584 3.95093 7.03526C3.80215 6.84462 3.63252 6.62573 3.46292 6.39546C3.24458 6.099 3.30791 5.68166 3.60437 5.46332C3.72354 5.37555 3.86225 5.3333 3.99972 5.33342L7.99976 5.33342L11.9998 5.33342C12.1373 5.3333 12.276 5.37555 12.3951 5.46332Z",
    fill: "#C64A50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentDown);
export default __webpack_public_path__ + "static/media/percent_down.bd287c7ac0fe83d975113b929e65e14c.svg";
export { ForwardRef as ReactComponent };